import { POSTHOG_EVENTS, type PosthogEventPayloads } from './events';
import { trackEvent } from './helpers';

export type LoginMethod = PosthogEventPayloads[typeof POSTHOG_EVENTS.LOGIN_SUCCESS]['method'];

// Set when a login starts, consumed when it lands: a reload or a regenerated
// session carries no mark and reports nothing.
const PENDING_KEY = 'login.pending';

export const markLoginPending = (): void => {
  try {
    window.sessionStorage.setItem(PENDING_KEY, 'true');
  } catch {
    /* empty */
  }
};

/** True only until the login that set the mark has been consumed. */
export const isLoginPending = (): boolean => {
  try {
    return window.sessionStorage.getItem(PENDING_KEY) !== null;
  } catch {
    return false;
  }
};

export const reportPendingLogin = (method: LoginMethod): void => {
  try {
    if (window.sessionStorage.getItem(PENDING_KEY) === null) return;

    window.sessionStorage.removeItem(PENDING_KEY);
  } catch {
    return;
  }

  trackEvent(POSTHOG_EVENTS.LOGIN_SUCCESS, { method });
};
